import { useEffect } from 'react';
import Cookies from 'universal-cookie';

let Storages = (() => {
    let userToken = 'x-auth-token'
    let defualtPacketType = 'defualtPacketType'
    let hashedPhoneNumber = 'hashedPhoneNumber'
    let userPass = 'userPass'
    let userName = 'userName'
    let allowReqAfterSec = 'allowReqAfterSec'
    let extendedTokenTime = 'extendedTokenTime'
    let refreshTime = 'refreshTime'
    let name = 'name'
    let balance = 'balance'
    let userInfo = 'userInfo'
    let options = { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365)) }



    let setUserToken = (token) => {
        try {
            new Cookies().set(userToken, token, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getUserToken = () => {
        try {
            return new Cookies().get(userToken);
        } catch (e) {
            console.log(e)
        }
    }

    let setDefualtPacketType = (token) => {
        try {
            new Cookies().set(defualtPacketType, token, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getDefualtPacketType = () => {
        try {
            return new Cookies().get(defualtPacketType);
        } catch (e) {
            console.log(e)
        }
    }

    let setBalance = (value) => {
        try {
            new Cookies().set(balance, balance, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getBalance = () => {
        try {
            return new Cookies().get(balance);
        } catch (e) {
            console.log(e)
        }
    }

    let removeUserToken = () => {
        try {
            setUserToken(undefined)

            return new Cookies().remove(userToken);
        } catch (e) {
            console.log(e)
        }
    }

    let setHashedPhoneNumber = (value) => {
        try {
            new Cookies().set(hashedPhoneNumber, value, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getHashedPhoneNumber = () => {
        try {
            return new Cookies().get(hashedPhoneNumber);
        } catch (e) {
            console.log(e)
        }
    }

    let setAllowReqAfterSec = (value) => {
        try {
            new Cookies().set(allowReqAfterSec, value, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getAllowReqAfterSec = () => {
        try {
            return new Cookies().get(allowReqAfterSec);
        } catch (e) {
            console.log(e)
        }
    }

    let setUserPass = (pass) => {
        try {
            new Cookies().set(userPass, pass, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getUserPass = () => {
        try {

            return new Cookies().get(userPass);
        } catch (e) {
            console.log(e)
        }
    }

    let setUserName = (name) => {
        try {
            new Cookies().set(userName, name, options);

        } catch (e) {
            console.log(e)
        }
    }

    let getUserName = () => {
        try {
            return new Cookies().get(userName);

        } catch (e) {
            console.log(e)
        }
    }

    let setExtendedTokenTime = (value) => {
        try {
            new Cookies().set(extendedTokenTime, value, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getExtendedTokenTime = () => {
        try {
            return new Cookies().get(extendedTokenTime);
        } catch (e) {
            console.log(e)
        }
    }

    let setRefreshTime = (value) => {
        try {
            new Cookies().set(refreshTime, (value * 1000), options);
        } catch (e) {
            console.log(e)

        }
    }

    let getRefreshTime = () => {
        try {
            return new Cookies().get(refreshTime);
        } catch (e) {
            console.log(e)
        }
    }

    let setUserInfo = (value) => {
        try {
            new Cookies().set(userInfo, value, options);
        } catch (e) {
            console.log(e)
        }
    }

    let getUserInfo = () => {
        try {
            return new Cookies().get(userInfo);
        } catch (e) {
            console.log(e)
        }
    }



    return {
        setUserToken: setUserToken,
        getUserToken: getUserToken,
        setDefualtPacketType: setDefualtPacketType,
        getDefualtPacketType: getDefualtPacketType,
        removeUserToken: removeUserToken,
        setHashedPhoneNumber: setHashedPhoneNumber,
        getHashedPhoneNumber: getHashedPhoneNumber,
        setUserPass: setUserPass,
        getUserPass: getUserPass,
        setUserName: setUserName,
        getUserName: getUserName,
        setAllowReqAfterSec: setAllowReqAfterSec,
        getAllowReqAfterSec: getAllowReqAfterSec,
        setUserInfo: setUserInfo,
        getUserInfo: getUserInfo,
        setExtendedTokenTime: setExtendedTokenTime,
        getExtendedTokenTime: getExtendedTokenTime,
        setRefreshTime: setRefreshTime,
        getRefreshTime: getRefreshTime,
        setBalance: setBalance,
        getBalance: getBalance
    }
})()

export default Storages